const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SwatchesCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        dragStartThreshold: 10,
        drag: true,
        slides: {
          perView: 4,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4,
              spacing: 0,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    this.els?.wrapper?.element.setAttribute('data-initialised', 'true')

    return slider
  }
}

if (!customElements.get('swatches-carousel')) {
  customElements.define('swatches-carousel', SwatchesCarousel)
}
